"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_time_ago_1 = __importDefault(require("react-time-ago"));
const utilities_1 = require("../../utilities");
const ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const styles_1 = require("@mui/material/styles");
const material_1 = require("@mui/material");
const Chat_1 = __importDefault(require("@mui/icons-material/Chat"));
const MarkChatRead_1 = __importDefault(require("@mui/icons-material/MarkChatRead"));
const material_2 = require("@mui/material");
const CommentsBlock_1 = __importDefault(require("./CommentsBlock"));
const OptionsButton_1 = __importDefault(require("./OptionsButton"));
require("./FoodCard.css");
const client_socket_1 = require("../../client-socket");
const ExpandMore = (0, styles_1.styled)((props) => {
    const { expand } = props, other = __rest(props, ["expand"]);
    return react_1.default.createElement(IconButton_1.default, Object.assign({}, other));
})(({ theme, expand }) => ({
    transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.shortest,
    }),
}));
const FoodCard = (foodEvent) => {
    var _a, _b;
    const [comments, setComments] = (0, react_1.useState)([]);
    const [markedGone, setMarkedGone] = (0, react_1.useState)(false);
    const [markedGoneBy, setMarkedGoneBy] = (0, react_1.useState)("");
    const [markedGoneByPic, setMarkedGoneByPic] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        const updateComments = () => {
            (0, utilities_1.get)(`/api/foodevents/${foodEvent._id}/comments`)
                .then((comments) => {
                setComments(comments);
            })
                .catch(console.warn);
        };
        updateComments();
        const handleCommentsUpdate = (foodEventId) => {
            if (foodEvent._id === foodEventId) {
                updateComments();
            }
        };
        client_socket_1.socket.on("CommentsUpdate", handleCommentsUpdate);
        return () => {
            client_socket_1.socket.off("CommentsUpdate", handleCommentsUpdate);
        };
    }, []);
    const handleMarkAsGone = () => {
        if (!markedGone) {
            (0, utilities_1.get)("/api/whoami").then((user) => {
                if (user.name) {
                    setMarkedGoneBy(user.name);
                }
                if (user.picture) {
                    console.log("setting markedGoneByPic", user.picture);
                    setMarkedGoneByPic(user.picture);
                }
                // setMarkingUser(user);
            });
        }
        if (!markedGone) {
            const reallyMarkAsGone = confirm(`Are you sure you want to mark this as gone? "${foodEvent.title || foodEvent.food_type}"`);
            if (reallyMarkAsGone) {
                console.log("marking as gone");
                setMarkedGone(!markedGone);
                fetch(`/api/foodevents/markAsGone/${foodEvent._id}`, {
                    method: "POST",
                }).catch(console.error);
            }
        }
    };
    const markedGoneByPicGetter = () => {
        // Handle Google avatars
        if (foodEvent.markedGonePic) {
            return (react_1.default.createElement(material_2.Avatar, { alt: "Avatar", src: foodEvent.markedGonePic, sx: { width: 20, height: 20, marginBottom: 0.3, alignSelf: "center" } }));
        }
        else if (foodEvent.markedGoneName) {
            // Default avatar or placeholder if login type is unknown
            return (react_1.default.createElement(material_2.Avatar, { className: "Card-avatarGradient", sx: { width: 20, height: 20, marginBottom: 0.3, alignSelf: "center", fontSize: "12px" }, "aria-label": "recipe" }, foodEvent.markedGoneName.at(0)));
        }
    };
    // this gets called when the user pushes "Submit", so their
    // post gets added to the screen right away
    const addNewComment = (commentObj) => {
        // TODO: what if instead of doing this we trigger a refresh
        // I really don't like mutating it here because it can cause inconsistencies
        // and lead the user to believe their comment was posted even if there is an error
        // In theory, this shouldn't even be needed once we implement sockets
        // ~rgabriel
        //
        // setComments(comments.concat([commentObj]));
    };
    const [expanded, setExpanded] = react_1.default.useState(false);
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    return (react_1.default.createElement(material_2.Card, { id: foodEvent._id, sx: { height: "100%", display: "flex", flexDirection: "column" } },
        react_1.default.createElement(material_2.CardHeader, { avatar: 
            // <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
            react_1.default.createElement(material_2.Avatar, { className: "Card-avatarGradient", "aria-label": "recipe" }, foodEvent.creator.at(0)), action: react_1.default.createElement(OptionsButton_1.default, Object.assign({}, foodEvent)), 
            // foodEvent.title ?? `${foodEvent.food_type} in ${foodEvent.location}`
            title: (_a = foodEvent.title) !== null && _a !== void 0 ? _a : (react_1.default.createElement(material_2.Typography, null,
                foodEvent.food_type,
                " in",
                " ",
                react_1.default.createElement(material_1.Tooltip, { title: `Open ${foodEvent.location} in whereis.mit.edu` },
                    react_1.default.createElement(material_1.Link, { sx: { fontWeight: "bold" }, target: "_blank", href: `https://whereis.mit.edu/?go=${foodEvent.location}` }, foodEvent.location)))), subheader: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_2.Typography, { variant: "body2" }, (_b = foodEvent.creator) !== null && _b !== void 0 ? _b : "Unknown"),
                react_1.default.createElement(material_1.Box, { sx: { fontSize: 12 } }, foodEvent.postedDate && react_1.default.createElement(react_time_ago_1.default, { date: foodEvent.postedDate, locale: "en-US" }))) }),
        foodEvent.photos.length > 0 && (react_1.default.createElement(material_2.CardMedia, { component: "img", height: "200", image: foodEvent.photos[0] })),
        react_1.default.createElement(material_2.CardContent, null,
            foodEvent.photos.length > 0 && (react_1.default.createElement(material_2.Typography, { variant: "body2", color: "text.secondary", sx: { whiteSpace: "pre-wrap", maxHeight: 100, overflow: "auto" } }, foodEvent.content)),
            foodEvent.photos.length < 1 && (react_1.default.createElement(material_2.Typography, { variant: "body2", color: "text.secondary", sx: { whiteSpace: "pre-wrap", maxHeight: 280.5, overflow: "auto" } }, foodEvent.content))),
        react_1.default.createElement(material_2.CardActions, { disableSpacing: true },
            !foodEvent.scheduled && !foodEvent.isGone && (react_1.default.createElement(material_1.Button, { variant: "contained", onClick: handleMarkAsGone, sx: { bgcolor: "secondary.main", color: "primary.contrastText", fontWeight: 570 } }, "Mark as gone?")),
            !foodEvent.scheduled && foodEvent.isGone && (react_1.default.createElement(material_2.Typography, { className: "isGone u-flex u-flexRow", variant: "body2", color: "secondary", sx: { overflow: "auto", maxWidth: "100%" } },
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, "Marked gone"),
                    " by ",
                    foodEvent.markedGoneName),
                " ",
                "\u00A0",
                markedGoneByPicGetter())),
            react_1.default.createElement(ExpandMore, { expand: expanded, onClick: handleExpandClick, "aria-expanded": expanded, "aria-label": "show/hide comments", sx: {
                    // DO NOT CHANGE THESE!!!!!!!!
                    paddingRight: 0,
                    paddingBottom: expanded ? 1 : 0,
                    paddingTop: expanded ? 0 : "auto",
                    paddingLeft: expanded ? 1 : "auto",
                    borderRadius: "16px 16px 16px 16px",
                } },
                react_1.default.createElement(material_2.Typography
                // makes it not be upside down
                , { 
                    // makes it not be upside down
                    sx: {
                        transform: expanded ? "scale(-1, -1)" : undefined,
                    } }, expanded ? react_1.default.createElement(MarkChatRead_1.default, null) : react_1.default.createElement(Chat_1.default, null)),
                " ",
                expanded ? (react_1.default.createElement(ExpandMore_1.default, { sx: { marginTop: 1 } })) : (react_1.default.createElement(ExpandMore_1.default, { sx: { marginBottom: 1 } })))),
        react_1.default.createElement(material_2.Collapse, { in: expanded, timeout: "auto", unmountOnExit: true },
            react_1.default.createElement(material_2.CardContent, { sx: { pt: 0, mt: 0 } },
                react_1.default.createElement(material_2.Typography, { variant: "overline" }, "Comments"),
                react_1.default.createElement(CommentsBlock_1.default, { comments: comments, foodevent: foodEvent, creator_userId: foodEvent.creator_userId, foodeventId: foodEvent._id, addNewComment: addNewComment })))));
};
exports.default = FoodCard;
